import { useEffect, useState } from "react";
import { useRouter } from "next/compat/router";
import ahoy from "@lib/ahoy";
import { analytics } from "@lib/trackers/analytics";

export function useButtonEventTracking() {
  const router = useRouter();

  const [path, setPath] = useState("/");

  useEffect(() => {
    setPath(router?.asPath);
  }, [router?.asPath]);

  return (
    trackingName,
    buttonName,
    userGroup,
  ) => {
    const defaultButtonEventData = {
      tracking_name: trackingName,
      button: buttonName,
      page: path,
    };

    if (userGroup) defaultButtonEventData.user_group = userGroup;

    if (path?.includes('catalogue') || path?.includes('braderie')) {
      const catalogData = {
        ...defaultButtonEventData,
        hub_slug: router?.query?.hub,
        listing_slug: router?.query?.listing?.pop(),
      };

      ahoy('$click', catalogData);
      analytics.track('$click', catalogData);
      return;
    }

    ahoy('$click', defaultButtonEventData);
    analytics.track('$click', defaultButtonEventData);
  };
}
